import React from 'react'
import { Link } from 'gatsby'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const InfoBannerSide = ({ store }) => {
  const data = useStaticQuery(graphql`
    query {
      pharmacy: file(relativePath: { eq: "pharmacy.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      cafe: file(relativePath: { eq: "cafe.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
    }
  `)
  const imageOne = getImage(data?.pharmacy)
  const sideBannerOne = [12]

  return (
    <>
      {sideBannerOne.includes(store) ? (
        <section className="mb-4">
          <Link
            href="tel:020 74851241"
            target="_blank"
            className="flex flex-col flex-1 p-4 text-white no-underline"
            style={{ backgroundColor: '#00a5aa' }}
          >
            <GatsbyImage
              image={imageOne}
              alt="Morrisons Pharmacy"
              style={{ maxWidth: '220px' }}
            />
            <div className="my-1">
              <p className="text-base font-semibold">
                Our new look Pharmacy is available across the road at
              </p>
            </div>

            <p className="text-lg font-bold">66 Chalk Farm Road, NW1 8AN</p>
            <span className="text-lg font-bold underline">
              Phone: 020 74851241
            </span>
          </Link>
        </section>
      ) : null}
    </>
  )
}

export default InfoBannerSide
